import React from 'react';
import { useTranslation } from 'react-i18next';

import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';

export const GeneralInfo: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();
  switch (region) {
    case 'us':
      return (
        <>
          <p>{t('privacy.generalInfo.paragraph_1', { address: tRegion('contactData.address') })}</p>
          <p>{t('privacy.generalInfo.paragraph_2')}</p>
          <ul style={{ listStyle: 'disc inside' }}>
            <li>{tRegion('privacy.generalInfo.paragraph_3_1')}</li>
            <li>{tRegion('privacy.generalInfo.paragraph_3_2')}</li>
          </ul>
          <p>{t('privacy.generalInfo.paragraph_4')}</p>
        </>
      );
    case 'eu':
      return (
        <>
          <p>{t('privacy.generalInfo.paragraph_1', { address: tRegion('contactData.address') })}</p>
          <p>{t('privacy.generalInfo.paragraph_2')}</p>
          <p>{tRegion('privacy.generalInfo.paragraph_3')}</p>
          <p>{t('privacy.generalInfo.paragraph_4')}</p>
        </>
      );
    default:
      assertNever(region);
  }
};
